module.exports = __webpack_public_path__ + "static/media/action_image_1.0e5afdde.jpg";